import React, { FC } from 'react'
import classNames from 'classnames'

import styles from './InscriptionAttribute.module.css'
import type { InscriptionAttribute as InscriptionAttributeType } from '@/utils/types/inscription'



const InscriptionAttribute: FC<{
	index: number
	attribute: InscriptionAttributeType
	className?: string
	total?: number
}> = (props) => {
	const { className, attribute, total, index } = props
	return (
		<div className={classNames({ [(props.className as any)]: !!className }, ((total as any) > 0 && (total as any)%2 && (total as any) - 1 === index) ? styles.fullRoot : styles.root)}>
			<div className={styles.column}>
				<p className={classNames(styles.key, 'text-xs', 'semibold')}>
					{attribute.trait_type.toUpperCase()}
				</p>
				<div>
					<span className={classNames(styles.value, 'text-xs', 'semibold')}>{attribute.value}</span>
					{attribute?.percent && (
						<span className={classNames(styles.percent, 'text-xs', 'semibold')}>
							{` - ${attribute?.percent}`}
						</span>
					)}
				</div>
			</div>
			{/*
			{rarity && (
				<div className={styles.column}>
					<p className={classNames(styles.key, 'text-xs', 'regular')}>RARITY</p>
					<p
						className={classNames(
							styles[TEST_RARITY.rarity.toLowerCase()],
							styles.value,
							'text-xs',
							'semibold'
						)}
					>
						{TEST_RARITY.rarity} - {TEST_RARITY.rarity_percentage}%
					</p>
				</div>
			)}
			*/}
		</div>
	)
}

export default InscriptionAttribute
